/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const ChevronDownOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m19.5 8.25-7.5 7.5-7.5-7.5"
})); // Fill


const ChevronDownFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M20.19 7.959a.707.707 0 0 0-.27-.334.775.775 0 0 0-.42-.125h-15c-.15 0-.29.043-.42.125a.707.707 0 0 0-.27.334.725.725 0 0 0-.04.436c.02.146.09.281.2.389l7.5 7.5c.14.139.33.216.53.216s.39-.077.53-.216l7.5-7.5c.11-.108.17-.243.2-.389s.02-.297-.04-.436z"
})); // DuoTone


const ChevronDownDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m19.5 8.25-7.5 7.5-7.5-7.5h15z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m19.5 8.25-7.5 7.5-7.5-7.5h15z"
}));
/**
  Icon ChevronDownIcon in arrows group
*/


export const ChevronDownIcon = createIcon('ChevronDownIcon', 'chevron-down', 'arrows', ChevronDownOutline, ChevronDownFill, ChevronDownDuotone, "0 0 24 24");